import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 1.5rem;
  flex-direction: column;

  button {
    width: 9.75rem;
    height: 3rem;
    margin-left: auto;
    margin-right: 2rem;
  }
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 1rem;
  column-gap: 2rem;

  input {
    width: 100%;
  }
`;
